import { SVGProps } from 'react';

import { ReactComponent as SistaMinutenLogoIconSVG } from '@/assets/icons/SistaMinutenLogoIcon.svg';

const SistaMinutenLogoIcon = (props: SVGProps<SVGSVGElement>) => <SistaMinutenLogoIconSVG {...props} />;

export default SistaMinutenLogoIcon;
